export const excludeNull = dadosForm => {
    dadosForm.bairro === '' && delete dadosForm.bairro;
    dadosForm.bairro == null  && delete dadosForm.bairro;
    dadosForm.estado == null && delete dadosForm.estado;
    dadosForm.logradouro == null && delete dadosForm.logradouro;
    dadosForm.complemento == null && delete dadosForm.complemento;
    dadosForm.estado == null && delete dadosForm.estado;
    dadosForm.numero == null && delete dadosForm.numero;
    dadosForm.cidade == null && delete dadosForm.cidade;
    dadosForm.cep == null && delete dadosForm.cep;

    return dadosForm;
};